/* eslint-disable consistent-return */
/* eslint-disable react/prop-types */
// @ts-nocheck

import { withRouter } from 'withRouter'
import Actions from 'actions'
import { find, omit } from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import EditableProfilePicture from './EditableProfilePicture'

export class EditableProfilePictureContainer extends React.Component {
  componentDidMount() {
    this.populateForm(this.props.residents)
  }

  UNSAFE_componentWillReceiveProps(nextProps: { residents: any }) {
    if (!this.props.residents && nextProps.residents) {
      this.populateForm(nextProps.residents)
    }
  }

  populateForm = (residentsList: any) => {
    const { addForm, router } = this.props
    const profile = find(residentsList, { id: router.params.id })

    if (!profile) return null

    addForm({
      ...omit(profile, 'name')
    })
  }

  render() {
    const { residents, router } = this.props
    const profile = find(residents, { id: router.params.id })
    if (!router.params || !residents) return null
    return (
      <EditableProfilePicture
        profile={profile}
        queryClient={this.props.queryClient}
      />
    )
  }
}

EditableProfilePictureContainer.propTypes = {
  addForm: PropTypes.func.isRequired,
  residents: PropTypes.array
}

const mapStateToProps = (state: { data: { residents: any } }) => ({
  residents: state.data.residents
})

const mapDispatchToProps = (dispatch: (arg0: any) => any) => ({
  addForm: (profile: any) =>
    dispatch(
      Actions.addForm({
        formId: 'editResident',
        initial: profile
      })
    )
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(EditableProfilePictureContainer))
